import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { cva, type VariantProps } from 'class-variance-authority';
import {
  inputErrorClasses,
  inputFrameClasses,
  inputInteractionClasses,
  inputPaddingClasses,
  inputRoundedClasses,
} from './KoobInputText';

export const textareaVariants = cva(
  `block w-full resize-none ${inputFrameClasses} ${inputInteractionClasses}`,
  {
    variants: {
      size: inputPaddingClasses,
      rounded: inputRoundedClasses,
      error: {
        true: inputErrorClasses,
      },
    },
    defaultVariants: {
      size: 'md',
      rounded: 'md',
    },
  },
);

type KoobInputTextareaProps = Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  'className' | 'style' | 'rows'
> &
  Omit<VariantProps<typeof textareaVariants>, 'error'> & {
    error?: boolean;
    /** Grows with content between minRows and maxRows (unbounded by default) */
    minRows?: number;
    maxRows?: number;
    'data-testid'?: string;
  };

const KoobInputTextarea = React.forwardRef<
  HTMLTextAreaElement,
  KoobInputTextareaProps
>(({ size, rounded, error = false, minRows = 3, maxRows, ...props }, ref) => (
  <TextareaAutosize
    ref={ref}
    minRows={minRows}
    maxRows={maxRows}
    className={textareaVariants({ size, rounded, error })}
    {...props}
  />
));

KoobInputTextarea.displayName = 'KoobInputTextarea';

export default KoobInputTextarea;
